require('angular-ui-bootstrap');

angular.module('vskoDropdown', ['ui.bootstrap'])

  .controller('vskoDropdownController', ['$scope', '$attrs',  function($scope, $attrs) {
    $scope.id = angular.isDefined($attrs.id) ? $attrs.id : 'dropdown_' + Math.floor((Math.random() * 10000000) + 1);
    $scope.caret = angular.isDefined($attrs.caret) ? $attrs.caret : 'true';
  }])

  .directive('vskoDropdown', function() {
    return {
      restrict: 'E',
      template: require('./vsko-dropdown.html'),
      controller: 'vskoDropdownController',
      transclude: true,
      scope: {
        label: '@?',
        type: '@?',
        icon: '@?',
        position: '@?'
      }
    };
  })
  .directive('vskoDropdownMenuitem', function() {
    return {
      restrict: 'E',
      require: '^vskoDropdown',
      template: require('./vsko-dropdown-menuitem.html'),
      replace: true,
      transclude: true,
      scope: {
        href:'@?'
      }
    };
  })
  .directive('vskoDropdownDivider', function() {
    return {
      restrict: 'E',
      require: '^vskoDropdown',
      template: require('./vsko-dropdown-divider.html'),
      replace: true
    };
  });
